export const api = {
  // 获取摄像机区域树
  queryCameraTree: "/bms/device/queryDeviceWorkGroupDeviceTree.json",
  // 获取摄像机设备组
  queryCameraList: "/vas/video/queryRegionalEquipmentTree.json",
  // 查询实时视频播放地址
  queryRealTimeVideoRtsp: "/vas/video/queryRealTimeVideoRtsp.json",
  // 新建文件夹
  addFolder: "/vas/video/addFolder.json",
  // 修改文件夹
  updateFolder: "/vas/video/updateFolder.json",
  // 删除文件夹
  deleteFolder: "/vas/video/deleteFolder.json",
  // 查询文件夹列表
  queryFolderList: "/vas/video/queryFolderList.json",
  // 查询文件夹详情
  queryFolderDetail: "/vas/video/queryFolderDetail.json",
  // 收藏(新增/修改)
  setMonitorPoints: "/vas/video/setMonitorPoints.json",
  // 删除收藏
  deleteFolderOrMonitorPoint: "/vas/video/deleteFolderOrMonitorPoint.json",
}
